<template>
	<validation-observer v-slot="{handleSubmit}" ref="formValidator">
		<b-form role="form" class="tw-mt-7" @submit.prevent="handleSubmit(onSubmit)">
			<!-- Institucion -->
			<base-input
				alternative
				name="institution"
				label="Institucion"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				:rules="{ required: true }"
				placeholder="Ingrese Institucion"
				v-model="client.institution"
				@input="errorMessage = null"
			/>

			<!-- Client -->
			<base-input
				alternative
				label="Cliente"
				name="Client"
				class="tw-mt-3"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				:rules="{ required: true }"
				placeholder="Ingrese cliente"
				v-model="client.client"
				@input="errorMessage = null"
			/>

			<!-- Contact -->
			<base-input
				alternative
				label="Contacto"
				name="contact"
				class="tw-mt-3"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				:rules="{ required: true }"
				placeholder="Ingrese contacto"
				v-model="client.contact"
				@input="errorMessage = null"
			/>

			<!-- Phone -->
			<base-input
				alternative
				name="phone"
				type="tel"
				class="tw-mt-3"
				label="Telefono"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				:rules="{ required: true }"
				placeholder="Ingrese Telefono"
				v-model="client.phone"
				@input="errorMessage = null"
			/>

			<!-- Email -->
			<base-input
				alternative
				name="email"
				label="Correo"
				class="tw-mt-3"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				:rules="{ required: true }"
				placeholder="Ingrese Correo"
				v-model="client.email"
				@input="errorMessage = null"
			/>

			<!-- Password -->
			<base-input
				alternative
				class="tw-mt-3"
				name="password"
				type="password"
				label="Contrasena"
				:disabled="$isUpdate"
				:rules="{ required: true }"
				label-classes="tw-px-3 tw-mb-1"
				placeholder="Ingrese Contrasena"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				v-model="client.password"
				@input="errorMessage = null"
			/>

			<div class="tw-flex tw-justify-between my-4">
				<base-button
					type="secondary"
					native-type="submit"
					:loading="loading"
				>{{$isUpdate ? 'Update' : 'Crear Solicitud'}}</base-button>
				<base-button type="danger" v-if="$isUpdate" @click="onResetForm">Cancel</base-button>
			</div>
		</b-form>
	</validation-observer>
</template>

<script>
import { ROLES } from '../../consts'
import { mapGetters, mapMutations } from 'vuex'
import { ClientsAPI } from '../../firebase/api.firebase'

import Multiselect from 'vue-multiselect'

const initialClient = (v = {}) => {
	return {
		id: v.id,
		email: v.email || '',
		phone: v.phone || '',
		client: v.client || '',
		contact: v.contact || '',
		password: v.password || '',
		institution: v.institution || '',
		role: ROLES.CLIENT,
	}
}

export default {
	name: 'ClientForm',
	components: {
		Multiselect,
	},
	data: () => ({
		// Booleans
		loading: false,

		// Objects
		client: initialClient(),

		// Array
		uploaded: [],
		role: ROLES,

		// Functions
		onShowClientInfo: () => { },
	}),
	computed: {
		...mapGetters('clients', ['$client', '$isUpdate'])
	},
	watch: {
		'$client.id'(id) {
			if (!id) return
			this.client = initialClient(this.$client)
		}
	},
	methods: {
		...mapMutations('clients', ['SET']),
		onResetForm() {
			this.client = initialClient()
			this.$refs.formValidator.reset()
			this.SET({
				isUpdate: false,
				client: { id: null }
			})
		},
		async onSubmit() {
			this.loading = true

			if (this.$isUpdate) {
				let client = initialClient(this.client)
				delete client.password

				await ClientsAPI.update(client.id, client)
			}
			else {
				const client = { ...this.client }
				delete client.id

				await ClientsAPI.save(client)
			}

			this.loading = false
			this.onResetForm()
		}
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
